export default __webpack_public_path__ + "static/landingCityB-1258f499a8c952ac1c60152eb41069be.png";